import * as Yup from 'yup';

import { phoneRegex } from '../../utils/utils';

export const ContactUsSchema = Yup.object().shape({
  firstName: Yup.string().min(1).required('First name is required'),
  lastName: Yup.string().min(1).required('Last name is required'),
  email: Yup.string().email().required('Email is required'),
  phoneNumber: Yup.string()
    .matches(phoneRegex, 'Invalid Nigerian phone number')
    .required('Phone number is required'),
  subject: Yup.string().min(1).required('Subject is required'),
  description: Yup.string().min(1).required('Please enter your description'),
});

export type ContactUsDataType = Yup.InferType<typeof ContactUsSchema>;

type InitialValues = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  subject: string;
  description: string;
};

export const contactUsInitialValues: InitialValues = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  subject: '',
  description: '',
};

export interface IContactUsResponse {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  subject: string;
  description: string;
}

export interface IContactUsRequest {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  subject: string;
  description: string;
}
